// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsUserForm__wrapper__1i6cE","submitResult":"SettingsUserForm__submitResult__2cNAy","actionWrapper":"SettingsUserForm__actionWrapper__klcsJ","wrapper2faOptions":"SettingsUserForm__wrapper2faOptions__2id09"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsUserForm/SettingsUserForm.css
// module id = 533
// module chunks = 0